import { render, staticRenderFns } from "./AdsOnApprovalView.vue?vue&type=template&id=4bc2029c&scoped=true"
import script from "./AdsOnApprovalView.vue?vue&type=script&lang=js"
export * from "./AdsOnApprovalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc2029c",
  null
  
)

export default component.exports